import { useNavigate, useParams } from 'react-router-dom';
import AssetProfileModal from './AssetProfileModal';

/**
 * Route /assets/:id — renders the full profile modal in standalone page context.
 */
export default function AssetDetail() {
  const { id }   = useParams();
  const navigate = useNavigate();

  return (
    <AssetProfileModal
      assetId={parseInt(id, 10)}
      onClose={() => navigate('/assets')}
      onRaiseWO={() => navigate('/work-orders/new?asset_id=' + id)}
    />
  );
}
